import { Box, Divider, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { BsPlusCircleDotted } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'
import Inventory from '../../../../../../api/db/Inventory'
import { IAddFormProps } from '../../../../../../shared/types'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import { InputFileCustomChild } from '../../../../../molecules/Input'
import { ValidatedButton, ValidatedForm, ValidatedTextInput } from '../../../../../organisms/validation/admin'


const initialValues = {

    name: "",
    brand: "",
    cartons: "",
    kilos_per_carton: "",
    cost_price_per_carton: "",
    selling_price_per_carton: "",
    selling_price_per_kilo: "",
    carton_type: ""
    
}

const validationSchema = Yup.object().shape({

    name: Yup.string().required().label("name"),
    brand: Yup.string().required().label("brand"),
    cartons: Yup.number().required().label("cartons"),
    kilos_per_carton: Yup.number().required().label("kilos_per_carton"),
    cost_price_per_carton: Yup.number().required().label("costprice_per_carton"),
    selling_price_per_carton: Yup.number().required().label("sellingprice_per_carton"),
    carton_type: Yup.number().required().label("carton_type"),
    
})

export default function AddNewProductForm({onDone, onFail}:IAddFormProps) {

    const [isLoading, setIsLoading] = useState(false)
    const current_user = useSelector(selectUserPropsState)
    const current_shop = useSelector(selectCurrrentAdminShop)?.name

    const handleOnSubmit = async (product: typeof initialValues)=>{

        try {

            const _product = {
                ...product,
                cost_price_per_carton: parseFloat(product.cost_price_per_carton),
                selling_price_per_kilo: parseFloat(product.selling_price_per_kilo),
                selling_price_per_carton: parseFloat(product.selling_price_per_carton),
                cartons: parseFloat(product.cartons),
                kilos_per_carton: parseFloat(product.kilos_per_carton)
            }

            const author = {
                email: current_user!.email,
                name: current_user!.name,
                uid: current_user!.uid
            }

            setIsLoading(true)
            await Inventory.addProduct(_product, current_user!.uid, current_shop!, author)
            setIsLoading(false)
            onDone()
            
        } catch (error) {
            setIsLoading(false)
            onFail(error)
            throw error
        }
        
    }

    const handleOnSubmitBulk = async (data: typeof initialValues[])=>{
        try {

            const author = {
                email: current_user!.email,
                name: current_user!.name,
                uid: current_user!.uid
            }

            setIsLoading(true)
            await Inventory.addProductsBulk(data, current_user?.uid!, current_shop!, author)
            onDone()
            setIsLoading(false)
            
        } catch (error) {
            setIsLoading(false)
            onFail()
            throw error
        }
    }
    
    return (
        <ValidatedForm
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleOnSubmit}
        >

            <Box
            >
                <Box
                    sx={{width: "100%", height: "20rem", overflow: "auto"}}
                >
                    <Stack 
                        direction="row"
                        sx={{width: "100%"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Product name</Typography>
                            <ValidatedTextInput name="name" type="text" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Brand</Typography>
                            <ValidatedTextInput name="brand" type="text" />
                        </Stack>
                    </Stack>
                    <Divider sx={{margin: "1rem 0"}} />
                    <Stack 
                        direction="row"
                        sx={{width: "100%"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Cartons</Typography>
                            <ValidatedTextInput name="cartons" type="number" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Kilos Per Carton</Typography>
                            <ValidatedTextInput name="kilos_per_carton" type="number" />
                        </Stack>
                    </Stack>
                    <Divider sx={{margin: "1rem 0"}} />
                    <Stack 
                        direction="row"
                        sx={{width: "100%"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Cost Price Per Carton</Typography>
                            <ValidatedTextInput name="costprice_per_carton" type="number" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Selling Price Per Carton</Typography>
                            <ValidatedTextInput name="sellingprice_per_carton" type="number" />
                        </Stack>
                    </Stack>
                    <Divider sx={{margin: "1rem 0"}} />
                    <Stack 
                        direction="row"
                        sx={{width: "100%"}}
                        spacing={2}
                    >
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Selling Price Per Kilo</Typography>
                            <ValidatedTextInput name="selling_price_per_kilo" type="number" />
                        </Stack>
                        <Stack sx={{width: "100%"}}>
                            <Typography variant="subtitle2" color="white">Carton Type</Typography>
                            <ValidatedTextInput name="carton_type" type="text" />
                        </Stack>
                    </Stack>
                </Box>

                <Box
                    sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
                >
                    
                    <Box
                        sx={{display: "inline", marginRight: "1rem"}}
                    >
                        <InputFileCustomChild 
                            accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                            onChange={handleOnSubmitBulk}
                            onFail={()=>{}}
                        >
                            <Typography sx={{textDecoration: "underline", fontSize: "13px"}} variant='subtitle2' color="grey.100" >Upload from excel</Typography>
                        </InputFileCustomChild>
                    </Box>
                    
                    <ValidatedButton 
                        startIcon={<BsPlusCircleDotted />} 
                        variant="contained" 
                        color="secondary" 
                        disableElevation={true}
                        loading={isLoading}
                    >
                        <Typography  color="primary" sx={{fontSize:"13px"}} >Add</Typography>
                    </ValidatedButton>
                </Box>

            </Box>
            
        </ValidatedForm>
    )
}
